module.exports = __webpack_public_path__ + "media/img/news-11-b2342a52.png";